<div class="table-responsive" [class.overflow-hidden]="dailyReportsService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover footable">
        <thead>
        <tr [ngClass]="{'noSort': dailyReportsService.data.allDailyReports.data.length < 2}">
            <th></th>
            <th (click)="orderBy('dailyReportNumber', $event)">ID#<span class="footable-sort-indicator"></span></th>
            <th *ngIf="dailyReportsService.buildings.length > 1" (click)="orderBy('building.name', $event)">
                Building<span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('createdBy.fullName', $event)">Report By<span class="footable-sort-indicator"></span></th>
            <th (click)="orderBy('startDate', $event)" class="footable-sorted-desc">
                Start Date<span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('endDate', $event)">End Date<span class="footable-sort-indicator"></span></th>
            <th (click)="orderBy('relieved', $event)">Relieved<span class="footable-sort-indicator"></span></th>
            <th (click)="orderBy('relievedBy', $event)">Relieved By<span class="footable-sort-indicator"></span></th>
            <th (click)="orderBy('status', $event)">Status<span class="footable-sort-indicator"></span></th>
        </tr>
        </thead>
        <tbody>
        <ng-template ngFor let-item [ngForOf]="dailyReportsService.data.allDailyReports.data" let-index="index">
            <tr (click)="$event.showDropdown || toggleCheck(item)" [ngClass]="{'footable-odd': (index % 2 === 0)}">
                <td>
                    <label class="img-checkbox">
                        <input type="checkbox" [ngModel]="item.checked">
                        <label><svg-checked></svg-checked></label>
                    </label>
                </td>
                <td>{{item.dailyReportNumber}}</td>
                <td *ngIf="dailyReportsService.buildings.length > 1">{{item.buildingName}}</td>
                <td>{{item.reportedBy}}</td>
                <td>{{item.startDate | mccDate:true: true}}</td>
                <td>{{item.endDate | mccDate:true: true}}</td>
                <td>{{item.relieved}}</td>
                <td>{{item.relievedBy}}</td>
                <td>
                    <span *ngIf="item.status === 'closed'" class="text-uppercase label label-closed">Closed</span>
                    <span *ngIf="item.status === 'draft'" class="text-uppercase label label-draft">Draft</span>
                </td>
            </tr>
        </ng-template>
        <tr *ngFor="let item of dailyReportsService.emptyRowService.emptyRow" style="cursor: default;">
            <td></td><td>&nbsp;</td><td *ngIf="dailyReportsService.buildings.length > 1"></td>
            <td></td><td></td><td></td><td></td><td></td><td></td>
        </tr>
        </tbody>
    </table>

    <empty-result-message [isEmpty]="!dailyReportsService.data.allDailyReports.total"
                          [isServiceUnavailable]="dailyReportsService.showServiceUnavailable"
                          [isLoading]="dailyReportsService.spinnerShow">
        You have no reports listed on the system<br>
        <span *ngIf="dailyReportsService.canEdit()">
            <a href="javascript://" (click)="dailyReportsService.isDailyReportsModalShow = true" class="mtv-primary-color clickable-text">add a report</a> now
        </span>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/daily-reports/daily-reports-list/daily-reports-list.component.html